module.exports = __webpack_public_path__ + "img/4_continue_tutorial.c73a3c04.gif";